import { StyleSheet, View } from 'react-native';
import { theme } from '@/constants/theme';

export function Step({ children }: { children: React.ReactNode }) { return <>{children}</>; }

export default function Stepper({ step, total }: { step: number; total: number }) {
  return (
    <View style={s.row}>
      {Array.from({ length: total }).map((_, i) => <View key={i} style={[s.dot, i + 1 === step && s.active, i + 1 < step && s.done]} />)}
    </View>
  );
}

const s = StyleSheet.create({
  row: { flexDirection: 'row-reverse', justifyContent: 'center', gap: 8 },
  dot: { width: 10, height: 10, borderRadius: 5, backgroundColor: '#323B67' },
  active: { width: 28, backgroundColor: theme.colors.primary },
  done: { backgroundColor: '#10B981' },
});
